import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { NgxMarqueeComponent } from '@omnedia/ngx-marquee';
@Component({
    selector: 'customized-section',
    standalone: true,
    imports: [ButtonModule, NgxMarqueeComponent],
    templateUrl: './customized-section.component.html',
    styleUrl: './customized-section.component.less',
})
export class CustomizedComponent {
    isHome: boolean = true;
}
